export const hasOAuth1Bootstrap = (auth = {}) => {
  const normalizedType = String(auth?.type || '')
    .trim()
    .toLowerCase();
  const authArguments = Array.isArray(auth?.arguments) ? auth.arguments : [];
  const hasAfterAuthHook = auth?.codeHooks?.afterAuth?.isActive === true && Boolean(String(auth?.codeHooks?.afterAuth?.path || '').trim());
  const hasAuthAction = Boolean(String(auth?.action?.actionId || '').trim());
  const hasXAuthCredentials = authArguments.some((argument) => ['username', 'password'].includes(String(argument?.key || '').trim()));

  return normalizedType === 'oauth1' && (hasAfterAuthHook || hasAuthAction || hasXAuthCredentials);
};
